import { useEffect } from "react";

const useHandleMouseMove = (scrollContainerRef) => {
  const scrollContainer = scrollContainerRef?.calendar?.el?.querySelector('.fc-view.fc-timeGridDay-view');
  const scrollSpeed = 4;

  let shouldDrag = true;

  const scrollHandler = (e) => {
    if (!scrollContainer || !shouldDrag) {
      return;
    }
  
    const rect = scrollContainer.getBoundingClientRect();
    let axisY = 0;
    let axisX = 0;
    
    const mouseY = e.clientY;
    const mouseX = e.clientX;

    // Y movement
    if (mouseY < rect.top + 80) axisY = -scrollSpeed;
    else if (mouseY > rect.bottom - 80) axisY = scrollSpeed;

    // X movement
    if (mouseX < rect.left + 80) axisX = -scrollSpeed;
    else if (mouseX > rect.right - 80) axisX = scrollSpeed;

    if (axisX || axisY) {
      scrollContainer.scrollBy(axisX, axisY);
    }
  }
  
  const mouseDownHandler = (e) => {
    scrollHandler(e);

    if (shouldDrag) {
      shouldDrag = false;
      setTimeout(() => {
        shouldDrag = true;
      }, 10);
    }
  }

  useEffect(() => {
    document.addEventListener('over', mouseDownHandler);
    return () => {
      document.removeEventListener('over', mouseDownHandler);
    }
  }, [])
};

export default useHandleMouseMove;